export const MAX_TEXT_LIMIT = 800
export const MAX_AMOUNT_LIMIT = 15
export const DEFAULT_PRINT_FONT_SIZE = 11

export const STATUS_CODES = {
  OK: 200,
  UNAUTHORIZED: 401,
}

export const DEFAULT_MSG = {
  StandardErrorMsg: 'Something Went wrong. Please try Again.',
  FormValidationMsg: 'Please fix the errors and try again.',
  SaveMsg: 'Saved successfully',
  SentMsg: 'Sent successfully',
  DeleteMsg: 'Deleted successfully',
  noRecordFound: 'No record found.',
  DeleteConfirmMsg: 'Are you sure you want to delete this record?',
  VoidConfirmMsg: 'Are you sure you want to void this record?',
  IsRequired: ' is required.',
  NoPermission: " You don't have permission.",
  InvalidSession: 'Session expired or invalid.',
  InvalidId: 'Invalid ID',
  UploadMsg: 'Uploaded successfully',
}

export const ALERT_TYPES = {
  primary: 'primary',
  secondary: 'secondary',
  success: 'success',
  danger: 'danger',
  warning: 'warning',
  info: 'info',
  light: 'light',
  dark: 'dark',
}

export const DATE_FORMATE = {
  1: 'DD/MMM/YYYY hh:mm:ss A',
  2: 'MMM DD, YYYY hh:mm:ss A',
  3: 'MMM DD, YYYY hh:mm A',
  4: 'DD/MMM/YYYY HH:mm:ss',
  5: 'HH:mm:ss',
  6: 'MMM DD, YYYY',
  7: 'hh:mm:ss A',
  8: 'hh:mm A',
  9: 'YYYY-MM-DD',
  10: 'DD/MM/YYYY',
}

export const GENDER_OPTIONS = [
  {label: 'Male', value: 'male'},
  {label: 'Female', value: 'female'},
]

export const DEFAULT_TABLE_PROPS = {
  data: [],
  page: 1,
  sizePerPage: 10,
  totalSize: 0,
}

export const INPUT_TYPES = {
  text: 'text',
  email: 'email',
  number: 'number',
  phone: 'phone',
  password: 'password',
  textArea: 'textArea',
  amount: 'amount',
  cnic: 'cnic',
}

export const PERMISSION_ROLES = {
  superAdmin: 'superAdmin',
  societyAdmin: 'societyAdmin',
  technicians: 'technicians',
  vendor: 'vendor',

}

export const elementIds = {
  VISITORS_QR_PRINT_CONTENT: 'VISITORS_QR_PRINT_CONTENT',
  INVOICE_PRINT_CONTENT: 'INVOICE_PRINT_CONTENT',
  OCCUPANTS_SELECT: 'OCCUPANTS_SELECT',
}

export const USER_TYPES = {
  admin: 'admin',
  resident: 'resident',
  guard: 'guard',
  technician: 'technician',
  vendor: 'vendor',
}

export const USER_TYPES_ROLE_ID = {
  admin: 1,
  subAdmin: 2,
  resident: 3,
  guard: 4,
  vendor: 5,
  plumber: 6,
  electrician: 7,
}

export const QR_TYPES = {
  visitor: 'V',
  resident: 'R',
}

export const PERMISSION_ID = {
  users: 1,
  societies: 2,
  invoices: 3,
  announcements: 4,
  permissions: 5,
  logs: 6,
  ads: 7,
  complaints: 8,
  emails: 9,
  pushNotifications: 10,
  brands: 11,
  brandsAds: 12,
  survey: 13,
  panicQueries: 14,
  tickets:17,
  ServiceCategory:15,
  Service:16,
  vendor:17
}

export const DURATION = [
  {label: '1 Month', value: '1'},
  {label: '3 Month', value: '3'},
  {label: '6 Month', value: '6'},
  {label: '1 Year', value: '12'},
]
